import { LegalAccountTaxationType } from '../../../graphql/schema';

export const is401kTaxationType = (taxationType: LegalAccountTaxationType): boolean => {
  return [LegalAccountTaxationType.Traditional_401K, LegalAccountTaxationType.Roth_401K].includes(taxationType);
};

export function formatAccountNameWithPurpose(accountName: string, purposeName: string | null | undefined): string {
  const trimmedPurpose = purposeName?.trim();
  const purposePrefix = trimmedPurpose ? `${trimmedPurpose} - ` : '';
  const trimmedAccountName = accountName.trim();
  return `${purposePrefix}${trimmedAccountName}`;
}

export function formatAccountNameForReview(
  accountName: string,
  purposeName: string | null | undefined,
  subAccountName: string,
  isTaxCoordinated: boolean
): string {
  const baseDisplayName = formatAccountNameWithPurpose(accountName, purposeName);
  const trimmedSubAccountName = subAccountName.trim();
  return isTaxCoordinated ? `${baseDisplayName} - ${trimmedSubAccountName}` : baseDisplayName;
}
